// extracted by mini-css-extract-plugin
export default {"previewContainer":"styles_previewContainer__tvjuF","previewContainer_pdf":"styles_previewContainer_pdf__dFPVn"};